import { HttpContextToken, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, finalize } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoaderService } from '../services/loader.service';

export const SHOW_LOADER = new HttpContextToken<boolean>(() => true);

const MICRO_SERVICE_ORIGINS = new Set(
  Object.values(environment.microAppService_url).map((cfg) => new URL(cfg.url).origin)
);

function isMicroServiceRequest(url: string): boolean {
  try {
    return MICRO_SERVICE_ORIGINS.has(new URL(url).origin);
  } catch {
    return false;
  }
}

let activeRequests = 0;

export const microServiceLoggingInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const showLoader = req.context.get(SHOW_LOADER);

  if (showLoader) {
    activeRequests++;
    console.debug('[LOADER-DBG] +req', activeRequests, req.method, req.url); // TEMP
    if (activeRequests === 1) {
      loaderService.show({ type: 'modal' });
    }
  }

  const isMicroService = isMicroServiceRequest(req.urlWithParams);
  const started = Date.now();
  const tag = '[MicroServiceHttp]';

  if (isMicroService) {
    console.log(`${tag} → ${req.method} ${req.urlWithParams}`);
  }

  return next(req).pipe(
    tap({
      next: (event) => {
        if (isMicroService && event instanceof HttpResponse) {
          console.log(`${tag} ← ${req.method} ${req.urlWithParams} ${event.status} (${Date.now() - started}ms)`);
        }
      },
      error: (err) => {
        if (isMicroService) {
          console.error(`${tag} ✗ ${req.method} ${req.urlWithParams} ${err.status ?? 0} (${Date.now() - started}ms)`);
        }
      },
    }),
    finalize(() => {
      if (showLoader) {
        activeRequests--;
        console.debug('[LOADER-DBG] -req', activeRequests, req.method, req.url); // TEMP
        if (activeRequests === 0) {
          loaderService.hide();
        }
      }
    }),
  );
};
